export enum SidePosition {
  Top = "top",
  Bottom = "bottom",
  Left = "left",
  Right = "right",
  Front = "front",
  Back = "back"
}
